'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _createId = require('../../utils/createId');

var _createId2 = _interopRequireDefault(_createId);

var _filterDOMProps = require('../../utils/filterDOMProps');

var _filterDOMProps2 = _interopRequireDefault(_filterDOMProps);

var _FocusManager = require('../../utils/FocusManager');

var _FocusManager2 = _interopRequireDefault(_FocusManager);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

if (process.env.SCALE_MEDIUM && process.env.SCALE_LARGE) {
  require('../../spectrum-css/menu/index.css');

  require('../../spectrum-css/menu/index-diff.css');
} else if (process.env.SCALE_LARGE) {
  require('../../spectrum-css/menu/index-lg.css');
} else {
  require('../../spectrum-css/menu/index.css');
}

if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHT) require('../../spectrum-css/menu/multiStops/light.css');
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARK) require('../../spectrum-css/menu/multiStops/dark.css');
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHTEST) require('../../spectrum-css/menu/multiStops/lightest.css');
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARKEST) require('../../spectrum-css/menu/multiStops/darkest.css');


var LIST_ITEM_SELECTOR = '.spectrum-Menu-item';
var NOT_DISABLED_SELECTOR = ':not(.is-disabled)';
var SELECTED_LIST_ITEM_SELECTOR = LIST_ITEM_SELECTOR + NOT_DISABLED_SELECTOR + '.is-selected';

var List = function (_Component) {
  _inherits(List, _Component);

  function List(props) {
    _classCallCheck(this, List);

    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));

    _this.listId = (0, _createId2.default)();
    return _this;
  }

  _createClass(List, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children,
          _props$role = _props.role,
          role = _props$role === undefined ? 'listbox' : _props$role,
          autoFocus = _props.autoFocus,
          _props$selectable = _props.selectable,
          selectable = _props$selectable === undefined ? false : _props$selectable,
          _props$id = _props.id,
          id = _props$id === undefined ? this.listId : _props$id,
          _props$typeToSelect = _props.typeToSelect,
          typeToSelect = _props$typeToSelect === undefined ? true : _props$typeToSelect,
          otherProps = _objectWithoutProperties(_props, ['className', 'children', 'role', 'autoFocus', 'selectable', 'id', 'typeToSelect']);

      return _react2.default.createElement(
        _FocusManager2.default,
        { itemSelector: LIST_ITEM_SELECTOR + NOT_DISABLED_SELECTOR, selectedItemSelector: SELECTED_LIST_ITEM_SELECTOR, typeToSelect: typeToSelect, autoFocus: autoFocus },
        _react2.default.createElement(
          'ul',
          _extends({
            id: id,
            className: (0, _classnames2.default)('spectrum-Menu', { 'is-selectable': selectable }, className),
            role: role
          }, (0, _filterDOMProps2.default)(otherProps)),
          children
        )
      );
    }
  }]);

  return List;
}(_react.Component);

List.propTypes = {
  className: _propTypes2.default.string,
  role: _propTypes2.default.string,
  selectable: _propTypes2.default.bool,
  autoFocus: _propTypes2.default.bool
};
List.defaultProps = {
  role: 'listbox'
};
exports.default = List;